import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { MoiaEmptyState } from '../feedback/MoiaEmptyState'

type ResourceNotFoundViewProps = {
  title?: string
  description?: string
  children?: ReactNode
}

export const ResourceNotFoundView = ({
  title,
  description,
  children,
}: ResourceNotFoundViewProps) => {
  const { t } = useTranslation()

  return (
    <MoiaEmptyState
      title={title ? title : t('common_notFoundPage_title')}
      description={
        description ? description : t('common_notFoundPage_description')
      }
    >
      {children}
    </MoiaEmptyState>
  )
}
